// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__o23i9","container":"styles_container__uYB88","title":"styles_title__7sPsk","active":"styles_active__VbULQ","body":"styles_body__8R1bg"};